interface UIState {
  isAllowedToProceedToCheckout: boolean;
  userHasSelectedShippingMethod: boolean;
}

const initialUIState: UIState = {
  isAllowedToProceedToCheckout: true,
  userHasSelectedShippingMethod: false,
};

export type { UIState };
export default initialUIState;
